import React from 'react';
import styled from 'styled-components';
import { Body5, Container } from '@ui';
import { FlatButton } from '@ui/buttons';
import { FormState } from '@ui/FormState';
import { createRfpTemplate } from '@services/rfp';

const FormFieldsWrapper = styled.div`
  max-width: 420px;
`;

const FieldInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const InputField = styled.input`
  border: 1px solid ${({ theme }) => theme.themeColors.border};
  color: ${({ theme }) => theme.themeColors.text};
  background-color: transparent;
  border-radius: 6px;
  width: 100%;
  padding: 12px 16px;
  font-size: 14px;
`;

const SubmitWrapper = styled.div`
  max-width: 440px;
`;

export function CreateTemplatePhase({ onCreated }) {
  const [name, setName] = React.useState('');
  const [formError, setFormError] = React.useState(null);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleSubmit = async () => {
    if (isSubmitting) {
      return;
    }

    const trimmedName = name.trim();
    if (!trimmedName) {
      setFormError('Please enter a template name.');
      return;
    }

    setFormError(null);
    setIsSubmitting(true);

    const { ok, data, error } = await createRfpTemplate({
      name: trimmedName,
    });

    setIsSubmitting(false);

    if (ok) {
      onCreated({ id: data.id, name: data.name });
      return;
    }

    setFormError(error || 'Something went wrong creating the template.');
  };

  return (
    <Container>
      <Container>
        <FormFieldsWrapper>
          <FieldInputWrapper>
            <Body5 bold>Template name</Body5>
            <InputField
              value={name}
              onChange={(e) => setName(e.target.value)}
              disabled={isSubmitting}
              autoComplete="off"
            />
          </FieldInputWrapper>
        </FormFieldsWrapper>
      </Container>
      <Container top={16}>
        <FormState error={formError} />
      </Container>
      <Container top={16} bottom={24}>
        <SubmitWrapper>
          <FlatButton fullWidth disabled={isSubmitting} onClick={handleSubmit}>
            {isSubmitting ? 'Creating template…' : 'Submit'}
          </FlatButton>
        </SubmitWrapper>
      </Container>
    </Container>
  );
}
